module.exports = __webpack_public_path__ + "static/media/KaTeX_Main-BoldItalic.5aeca883.woff";